module.exports = __webpack_public_path__ + "img/Draumkvedet_Maleri-av-jente-med-lur.95f1ec8b.jpg";